import React from "react"

import type { BadgeProps } from "@chakra-ui/react"
import { Badge } from "@chakra-ui/react"

import { toSentenceCase } from "@supliful/domain"

const statusColors = {
  NEW: "gray",
  READY_TO_SHIP: "primary",
  SHIPPED: "primary",
  RETURNED: "yellowBright",
} as const

type ShipmentStatusType = keyof typeof statusColors

type StatusBadgeProps = BadgeProps & {
  status: string
}

export const ShipmentStatusBadge = ({ status, ...rest }: StatusBadgeProps) => {
  // Type guard to check if status is valid
  const color =
    status in statusColors ? statusColors[status as ShipmentStatusType] : "gray" // Fallback color for unknown statuses

  return (
    <Badge colorScheme={color} {...rest}>
      {toSentenceCase(status)}
    </Badge>
  )
}
